module.exports = __webpack_public_path__ + "static/media/papa.90c4c38a.png";